import $http from '../../shared/http';
import { compile } from 'path-to-regexp';
import { isEmpty } from '../../shared/utils';

export const wellKnown = {
  namespaced: true,
  mutations: {
    setWellKnownEndpoints: (_state, data) => {
      localStorage.setItem('wellknown_endpoints', JSON.stringify(data));
    },
  },
  actions: {
    async fetchWellKnownEndpoints({ commit }) {
      return $http('v2')
        .get('.well-known/endpoints')
        .then((response) => {
          commit('setWellKnownEndpoints', response.data.data);
          return response;
        });
    },
  },
};

/**
 * @returns {Record<string, {route: string; method: import('axios').Method}>}
 */
function wellKnownEndpoints() {
  try {
    return JSON.parse(localStorage.getItem('wellknown_endpoints'));
  } catch (error) {
    return {};
  }
}

/**
 *
 * @param {string} endpointName
 * @param {Record<string, string | number>} params
 */
export function resolveWellKnownEndpoint(endpointName, params = {}, queries = {}) {
  // For debug
  // console.log(endpointName, params);
  let endpointObject = wellKnownEndpoints()?.[endpointName];
  if (!endpointObject) {
    return null;
  }
  const computedRoute = compile(endpointObject.route)(params);
  let url = computedRoute.replace(/^\/v(?:\d+)/, '');
  if (!isEmpty(queries)) {
    url = `${url}?${new URLSearchParams(queries).toString()}`;
  }
  return { url, method: endpointObject.method };
}
